import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from '../../css/admin/Status.module.css';
import { isApp } from '../../utils/isApp'; // [APP-FORK]

const STATUS_TABS = [
  { key: 'home', label: '홈' },
  { key: 'gift', label: '기프트 관리' },
  { key: 'sales', label: '판매현황' },
  { key: 'staff', label: '직원 관리' },
];

/** 상점현황 상단 탭. 정산명세서 탭은 점주에게만 보인다(showSettlement). */
export default function StatusTabs({ storeNo, activeTab, showSettlement }) {
  const navigate = useNavigate();
  const navRef = useRef(null);

  // 탭 너비가 고정이라 마지막 탭은 화면 밖에 있다 — 정산명세서 화면에서는 보이도록 옮긴다.
  useEffect(() => {
    if (activeTab === 'settlement' && navRef.current) {
      navRef.current.scrollLeft = navRef.current.scrollWidth;
    }
  }, [activeTab, showSettlement]);

  return (
    <div
      ref={navRef}
      className={
        isApp() ? `${styles.topNav} ${styles.topNavApp}` : styles.topNav
      }
    >
      {STATUS_TABS.map(tab => (
        <button
          key={tab.key}
          type="button"
          className={`${styles.navBtn} ${activeTab === tab.key ? styles.active : ''}`}
          onClick={() => navigate(`/mobile/giftstatus/${storeNo}/${tab.key}`)}
        >
          {tab.label}
        </button>
      ))}
      {showSettlement && (
        <button
          type="button"
          className={`${styles.navBtn} ${activeTab === 'settlement' ? styles.active : ''}`}
          onClick={() => navigate(`/mobile/${storeNo}/settlement`)}
        >
          정산명세서
        </button>
      )}
    </div>
  );
}
